import React, { lazy } from 'react';
export function MentorSection() {
  return <section className="py-12 md:py-20 px-4 bg-[#121212] overflow-hidden" data-id="element-244" data-mp="1lwhklrfikodf">
      <div className="max-w-6xl mx-auto" data-id="element-245" data-mp="1pctuafdcdnm2">
        <h2 className="text-3xl md:text-5xl font-black text-center text-white mb-12 uppercase tracking-tight" data-id="element-246" data-mp="1kejvzvwbm6w8">
          Conoce a la experta que dicta el programa
        </h2>

        <div className="flex flex-col md:flex-row items-center gap-8 md:gap-16" data-id="element-247" data-mp="1fha140q5x310">
          {/* Image Column */}
          <div className="w-full md:w-1/2 relative" data-id="element-248" data-mp="2d51yaup8048l">
            <div className="absolute -inset-4 bg-[#9C16A3]/20 blur-3xl rounded-full" data-id="element-249" data-mp="2855vgys9eium"></div>
            <img src="https://cdn.magicpatterns.com/uploads/mx8HfviD1v1mEWXwrBn4Nk/ChatGPT_Image_13_jun_2026,_12_10_52_a.m._(1).png" alt="Maria Gimenez - Mentora de Luxury Browes" className="relative z-10 w-full max-w-md mx-auto rounded-3xl shadow-2xl border-2 border-[#FC9DFF]/30" loading="lazy" data-id="element-250" data-mp="23ccnm21huueb" />
          </div>

          {/* Content Column */}
          <div className="w-full md:w-1/2 text-left" data-id="element-251" data-mp="2r0vzerjr5pb5">
            <h3 className="text-2xl md:text-4xl font-bold text-[#FC9DFF] mb-6" data-id="element-252" data-mp="t6x77x7nqyv9">
              María Giménez
            </h3>

            <div className="space-y-6 text-gray-300 text-lg md:text-xl leading-relaxed" data-id="element-253" data-mp="y45olvkzeyvg">
              <p data-id="element-254" data-mp="jfjb7zex0h6v">
                María Giménez es especialista en belleza con más de{' '}
                <span className="text-white font-bold" data-id="element-255" data-mp="oduj44lnghmg">
                  25 años de experiencia
                </span>{' '}
                en el mundo beauty. Apasionada por la formación y por descubrir
                nuevas técnicas, viajó a España para perfeccionarse y terminó
                realizando un Máster de 6 meses en Brow Extensions, una técnica
                avanzada de extensión de cejas pelo por pelo.
              </p>

              <p data-id="element-256" data-mp="1uv7yyszztk8q">
                Hoy trae ese conocimiento a Argentina a través de{' '}
                <span className="text-white font-bold" data-id="element-257" data-mp="1utepz71wqnxk">Luxury Browes</span>, un
                programa creado para enseñar desde cero cómo lograr cejas más
                naturales, realistas y elegantes, ayudando a lashistas, brow
                artists y esteticistas a sumar un servicio premium y rentable a
                su negocio.
              </p>
            </div>

            <div className="mt-8 p-4 rounded-xl bg-[#9C16A3]/10 border border-[#9C16A3]/30 inline-block" data-id="element-258" data-mp="1ofhgl5pownxe">
              <p className="text-[#FC9DFF] font-semibold italic" data-id="element-259" data-mp="1jhpfpm72hrh2">
                "Mi misión es que logres resultados de excelencia y transformes
                tu carrera profesional."
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}